import Modalheader from "../../../components/header";
import ModalBody from "../../../components/body";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import useModal from "../../../useModal";

const AdminModalMissionDatesMissionConfirmation = () => {
    const {toggle}=useModal()

    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>
                Confirmation de modification de la période de la mission
            </Modalheader>
            <ModalBody>
                <p>Êtes-vous sûr de vouloir modifier les périodes de la mission ?</p>
            </ModalBody>
            <ModalFooter >
                <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>Annuler</Button>
                <Button size={'LG'}>Confirmer</Button>
            </ModalFooter>
        </>
    )
}

export default AdminModalMissionDatesMissionConfirmation